<template>
  <section>
    <div class="banner has-text-centered">
      <h3>NUESTROS PRODUCTOS</h3>
    </div>

    <div class="container">

      <div class="section">

        <div class="columns " v-for="cols in categories">

          <div class="column has-text-centered wow fadeIn" v-bind:data-wow-delay="product.delay" v-for="product in cols">
            <div class="box-products has-text-centered">
              <div class="overlay">
                <div class="text">
                  <router-link :to="product.link">Ver productos!</router-link>

                </div>
              </div>
              <h1 v-html="product.title">

              </h1>
              <p class="description">
                {{product.description}}
              </p>
              <p>

                <img :src="product.image" v-bind:alt="product.description">
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>
<script>
import WOW from 'wowjs'
import img1 from '../assets/images/categories/1.jpg'
import img2 from '../assets/images/categories/2.jpg'
import img3 from '../assets/images/categories/3.jpg'
import img4 from '../assets/images/categories/4.jpg'
import img5 from '../assets/images/categories/5.jpg'
import img6 from '../assets/images/categories/6.jpg'
import 'wowjs/css/libs/animate.css'
export default {
  name: 'content',
  data() {
    return {
      categories: [
        [
          {
            title: 'BEDDING & LITTER <br> CAMAS',
            image: img1,
            description: 'Marlo para Gatos - Marlo para Roedores - Viruta de Marlo',
            link: 'bedding-and-litter-camas',
            delay: '.1s'
          },
          {
            title: 'NATURAL HAY <br> PASTURAS',
            image: img2,
            description: 'Alfalfa en Pellets - Alfalfa en Rama - Alfalfa en Cubos - Heno en rama',
            link: 'natural-hay-pasturas',
            delay: '.5s'
          },
          {
            title: 'NATURAL MIX<br> AVES',
            image: img3,
            description: ' Mix Canarios - Mix Silvestres - Mix Periquitos - Mix Loreos - Mijo con Vitaminas - Girasol Confitero - Alpiste con Vitaminas',
            link: 'natural-mix-aves',
            delay: '.9s'
          }
        ],
        [
          {
            title: 'NATURAL MIX <br> ROEDORES',
            image: img4,
            description: ' Mix Hamster - Mix Cobayos',
            link: 'natural-mix-roedores',
            delay: '1.3s'
          },
          {
            title: 'COMPLETE FOOD <br> (ALL IN ONE)',
            image: img5,
            description: 'Alimento para conejos - Alimento para Chinchillas',
            link: 'complete-food',
            delay: '1.7s'
          }
        ]
      ]
    }
  },
  mounted() {
    // const lib = WOW.WOW
    // const Wow = new lib()
  }
}
</script>
<style lang="scss" scoped>
$green:#7cb542;
$yellow: #F3AB3C;
$gray:#e6e6e6;
.banner {
  background: url('~@/assets/images/desktop/back_nuestrosproductos.jpg') no-repeat center center $gray;
  background-size: cover;
  width: 100%;
  height: 147px;
  display: table;
  h3 {
    font-size: 2em;
    font-family: 'Montserrat';
    font-weight: bold;
    display: table-cell;
    vertical-align: middle;
  }
}

.box-products {
  position: relative;
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: .5s ease;
    background-color: white;
    border: $green 1px solid;
    .text {
      color: white;
      font-size: 20px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      a {
        background: $yellow;
        color: black;
        padding: .5em .5em;
        font-size: 1rem;
      }
    }
  }
  &:hover .overlay {
    opacity: 1;
  }

  height: auto;
  background: $green;
  h1 {
    font-family: 'Montserrat';
    font-size: 1.7rem;
    font-weight: bold;
    color: white;
    line-height: 1.4;
    padding: 1em 0;
    height: 120px;
  }
  p {
    &.description {
      height: 100px;
    }
    padding: 1em;
  }
}

@media only screen and (max-width:48em) {
  .banner {
    h3 {
      font-size: 1.8em;
    }
  }

  .box-products {
    h1 {
      font-size: 1.6rem;
      height: auto;
      padding: .5rem;
    }
    p {
      &.description {
        height: auto;
      }
      padding: .5rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/content.vue